import {
  CardWrapperButton,
  CardWrapperRoot,
  CardWrapperProps,
  Style,
} from './CardWrapperElements'

/**
 * @deprecated This component should not be used. Use the `Card` component instead.
 */
export const CardWrapper = ({
  children,
  padding = '1rem',
  style,
  onClick,
}: CardWrapperProps) => {
  if (onClick) {
    const buttonStyle: Style = {
      appearance: 'none',
      WebkitAppearance: 'none',
      margin: 0,
      boxSizing: 'border-box',
      display: 'block',
      width: '100%',
      font: 'inherit',
      color: 'inherit',
      textAlign: 'start',
      cursor: 'pointer',
      padding,
      border: 'var(--border-default)',
      background: 'var(--palette-white)',
      borderRadius: '1.25rem',
      ...style,
    }

    return (
      <CardWrapperButton onClick={onClick} style={buttonStyle}>
        {children}
      </CardWrapperButton>
    )
  }

  const rootStyle: Style = {
    padding,
    border: 'var(--border-default)',
    background: 'var(--palette-white)',
    borderRadius: '1.25rem',
    cursor: 'auto',
    ...style,
  }

  return <CardWrapperRoot style={rootStyle}>{children}</CardWrapperRoot>
}
